
import { getNewsPaperURL } from '@/api/desktop/images'
import { chartFontFamily, fetchDataErrorText, retryOrPollUntil } from '@/draw-core/utils/common'

export const guan_ya_he = [
  {
    imgName: 1
  },
  {
    imgName: 2
  },
  {
    imgName: 3
  },
  {
    imgName: 4
  },
  {
    imgName: 5
  },
  {
    imgName: 6
  },
  {
    imgName: 7
  },
  {
    imgName: 8
  },
  {
    imgName: 9
  },
  {
    imgName: 10
  }
]

// 起值: 冠+亚和数-3，若结果＜3请以3显示，

// (例如冠1亚2，和值为3，3-3=0＜3请以3显示)

// 迄值: 冠+亚和数+3，若结果＞19请以19显示

// (例如冠10亚9，和值为19，19+3=22＞19请以19显示)
export const guanYaYuCe = (guan = 0, ya = 0) => {
  const heVal = guan + ya
  const start = heVal - 3 < 3 ? 3 : heVal - 3
  const end = heVal + 3 > 19 ? 19 : heVal + 3
  return {
    start,
    end
  }
}

// 從carList資料中隨機取得兩組不重複資料
export const getRandomTwoPair = (arr = [], forceNum = 0) => {
  const carListCopy = [...arr]
  // 使用 forceNum 指定 firstPair，否則使用隨機產生
  let firstPair
  let secondPair
  if (forceNum > 0) {
    firstPair = carListCopy[forceNum - 1]
    carListCopy.splice(forceNum - 1, 1)
    secondPair = carListCopy.splice(getRandomInt(carListCopy.length), 1)[0] // 從 carListCopy 取得唯一元素
  } else {
    firstPair = carListCopy.splice(getRandomInt(arr.length), 1)[0] // 從 carListCopy 取得唯一元素
    secondPair = carListCopy.splice(getRandomInt(carListCopy.length), 1)[0] // 從 carListCopy 取得唯一元素
  }
  return { firstPair, secondPair }
}

// 產生指定範圍的隨機整數
function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max))
}

// export const getRandomTwoPair = (arr = []) => {
//   const carListCopy = [...arr]
//   // 使用 forceNum 指定 firstPair，否則使用隨機產生
//   const firstPair = carListCopy.splice(getRandomInt(arr.length), 1)[0] // 從 carListCopy 取得唯一元素
//   const secondPair = carListCopy.splice(getRandomInt(carListCopy.length), 1)[0]// 從 carListCopy 取得唯一元素
//   return { firstPair, secondPair }
// }

/**
 * 從給定的陣列中返回隨機選取的項目。
 *
 * @param {Array} arr - 要從中選取隨機項目的陣列。默認為空陣列。
 * @return {*} - 陣列中隨機選取的項目。如果輸入不是陣列或為空，則返回 `null`。
 */
export const getRandomItem = (arr = []) => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return null // 或者抛出错误
  }
  const randomIndex = Math.floor(Math.random() * arr.length)
  return arr[randomIndex]
}

export const canvasStyle = {
  paddintTop: 116 + 3,
  paddingX: 36,
  rectWidth: 300,
  blockSpacing: 8,
  canvasWidth: 1000,
  canvasHeight: 1106,
  fontFamily: chartFontFamily,
  blockStrokeStyle: '#303D47',
  blockBorderRaidus: 12
}

// 繪圖區塊
export const drawBlock = async(ctx, x, y, callback) => {
  ctx.save()
  try {
    await callback(ctx, x, y)
  } finally {
    ctx.restore()
  }
}

/**
 * 將圖像插入到指定的座標上的 canvas 上。
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布渲染內容。
 * @param {number} x - 圖像放置的 x 座標。
 * @param {number} y - 圖像放置的 y 座標。
 * @param {object} imgInfo - 圖像的相關資訊，包括路徑、x、y、寬度和高度。
 * @param {function} callback - 在圖像載入後執行的回調函數。
 */
export const insertImage = (ctx, x, y, imgInfo, callback) => {
  return new Promise((resolve, reject) => {
    const imgObj = new Image()

    imgObj.onerror = () => {
      reject(new Error(`Failed to load image: ${imgInfo.path}`))
    }

    imgObj.onload = () => {
      ctx.drawImage(
        imgObj,
        imgInfo.x,
        imgInfo.y,
        imgInfo.width,
        imgInfo.height
      )

      if (typeof callback === 'function') {
        callback(ctx, x, y)
      }

      resolve()
    }

    imgObj.src = imgInfo.path
  })
}

/**
 * 在畫布上繪製標題區塊。
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布渲染上下文。
 * @param {number} x - 標題區塊的 x 座標。
 * @param {number} y - 標題區塊的 y 座標。
 * @param {string} text - 要顯示的標題文字。
 * @return {void} 此函數不返回任何值。
 */
export const blockTitle = (ctx, x, y, text) => {
  ctx.beginPath()
  ctx.font = `16px ${canvasStyle.fontFamily}`
  ctx.fillStyle = '#000000'
  ctx.fillText(text, x + canvasStyle.blockSpacing, y + canvasStyle.blockSpacing * 3)
  ctx.closePath()
}

/**
 * 在畫布上繪製最新10期冠軍預測。
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布渲染內容。
 * @param {Object} params - 繪製區塊的參數。
 * @param {number} [params.blockSpacing=canvasStyle.blockSpacing] - 區塊之間的間距。
 * @param {number} [params.rectWidth=canvasStyle.rectWidth] - 矩形的寬度。
 * @param {number} [params.paddingX=canvasStyle.paddingX] - 水平內距。
 * @param {number} [params.paddintTop=canvasStyle.paddintTop] - 頂部的垂直內距。
 * @param {Object} params.block - 區塊物件大小。
 * @param {number} [params.gap=0] - 區塊之間的間距。
 * @param {Object} params.imgInfo - 圖像資訊。
 * @param {Object} params.pos - 區塊的位置。
 * @param {number} params.pos.x - 區塊的x坐標。
 * @param {number} params.pos.y - 區塊的y坐標。
 * @param {Function} [callback] - 回調函數。
 * @return {void} 此函數不返回任何內容。
 */
export const championshipPredictionBlock = (ctx, params = {}, callback) => {
  const {
    blockSpacing = canvasStyle.blockSpacing,
    rectWidth = canvasStyle.rectWidth,
    paddingX = canvasStyle.paddingX,
    paddintTop = canvasStyle.paddintTop,
    block = {},
    gap = 0,
    imgInfo = {},
    pos = { x: 0, y: 0 }
  } = params
  ctx.save() // 儲存當下座標狀態
  ctx.translate(pos.x * (block.width + gap) + blockSpacing, pos.y * (block.height + gap) + 7)
  ctx.beginPath()
  ctx.roundRect(pos.x, pos.y, block.width, block.height, 4)
  ctx.strokeStyle = '#9D9D9D'
  ctx.lineWidth = 1
  ctx.stroke()
  ctx.closePath()

  const imgObj = new Image()
  imgObj.src = imgInfo.path
  imgObj.onload = () => {
    ctx.save()
    ctx.translate(paddingX + rectWidth + (blockSpacing * 2), paddintTop + blockSpacing)
    ctx.drawImage(imgObj, pos.x * (block.width + gap) + block.width - imgInfo.width - 3, pos.y * (block.height + gap) + 5, imgInfo.width, imgInfo.height)
    ctx.restore()
  }
  if (typeof callback === 'function') {
    callback(ctx, pos.x, pos.y)
  }
  ctx.restore()
}

/**
 * 根據提供的參數，在畫布上繪製冠軍定位走勢折線圖。
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布的2D渲染內容。
 * @param {number} x - 圖表開始位置的x坐標。
 * @param {number} y - 圖表開始位置的y坐標。
 * @param {Object} params - 包含可選參數的物件：
 *    - {Array} mapData - 圖表的數據。
 *    - {number} rectWidth - 圖表區塊的寬度。
 *    - {string} fontFamily - 圖表文字的字體。
 *    - {number} blockSpacing - 圖表區塊之間的間距。
 *    - {Array} championshipMissing - 冠號遺漏的數據。
 *    - {function} blockTitle - 顯示區塊標題的函數。
 *    - {number} blockBorderRaidus - 區塊邊框的半徑。
 *    - {string} blockStrokeStyle - 區塊邊框的顏色。
 *    - {string} periodFontSize - 期號標題的字體大小。
 *    - {number} periodLetterSpacing - 期號間距。
 *    - {string} blockBackgroundColor - 區塊的背景顏色。
 *    - {string} neutrialStyle - 期號標題水平背景顏色。
 *
 * @return {void}
 */
export const championshipLineChart = (ctx, x, y, params = {}) => {
  const {
    mapData = [],
    rectWidth = canvasStyle.rectWidth, // 區塊寬度
    fontFamily = canvasStyle.fontFamily, // 字體
    blockSpacing = canvasStyle.blockSpacing, // 區塊間距
    champinshipMissing = [],
    blockTitle = () => {}, // 區塊標題，請加入預設function參數
    blockBorderRaidus = 12, // 區塊圓角大小
    blockStrokeStyle = canvasStyle.blockStrokeStyle, // 區塊邊框顏色
    periodFontSize = '10px', // 期號字體大小
    periodLetterSpacing = 0, // 期號間距
    blockBackgroundColor = '#FFFFFF',
    neutrialStyle = '#EDEDED'
  } = params

  const boxWidth = 18
  const teamColorList = mapData.map(car => ({ teamColor: car.teamColor, number: car.number }))
  // ctx.save()
  ctx.beginPath()
  ctx.roundRect(x, y, rectWidth, 319, blockBorderRaidus)
  ctx.fillStyle = blockBackgroundColor
  ctx.fill()
  ctx.strokeStyle = blockStrokeStyle
  ctx.lineWidth = 2
  ctx.stroke()
  ctx.closePath()

  // 期號
  const periodPosYaxis = y + (blockSpacing * 4) + 4
  const periodTitle = {
    title: '期号',
    x: x + blockSpacing + 10,
    y: periodPosYaxis + 14,
    textColor: '#000000'
  }

  // 裁切範圍
  ctx.save()
  ctx.beginPath()
  ctx.roundRect(x + 2, y + 38, rectWidth - 4, 280, blockBorderRaidus)
  ctx.fillStyle = '#ffffff'
  ctx.fill()
  ctx.closePath()
  ctx.restore()

  ctx.beginPath()
  if (typeof blockTitle === 'function') {
    blockTitle()
  }
  ctx.closePath()

  ctx.fillStyle = '#000000'
  const latestPeriod10Miss = '近10期遗漏'
  const latestPeriod10MissMeasure = ctx.measureText(latestPeriod10Miss).width
  ctx.font = `14px ${fontFamily}`
  ctx.fillText(latestPeriod10Miss, x + rectWidth - latestPeriod10MissMeasure, y + (blockSpacing * 3))
  ctx.fillStyle = '#000000'

  // 期號標題水平背景
  ctx.beginPath()
  ctx.fillStyle = neutrialStyle
  ctx.fillRect(x + 2, periodPosYaxis, rectWidth - 4, 20)
  ctx.closePath()

  // 期號標題字
  ctx.fillStyle = periodTitle.textColor
  ctx.font = `11px ${fontFamily}`
  ctx.fillText(periodTitle.title, periodTitle.x, periodTitle.y)

  teamColorList.forEach((item, index, arr) => {
    const periodTitleItemXaxis = x + 38 + ((index + 1) * 18) + ((index + 1) * 6)
    const periodTitleItemYaxis = periodPosYaxis + 4
    ctx.beginPath()
    // 期號 1~10 背景
    ctx.roundRect(periodTitleItemXaxis, periodTitleItemYaxis, boxWidth, 13, 2)
    ctx.fillStyle = '#ACB2B7'
    ctx.fill()
    ctx.closePath()

    // 期號 1~10
    ctx.font = `12px ${fontFamily}`
    ctx.fillStyle = '#000000'
    ctx.fillText(item.number, periodTitleItemXaxis - (ctx.measureText(item.number).width / 2) + (boxWidth / 2), periodTitleItemYaxis + 11)
  })
  const points = []
  champinshipMissing.slice(0, 10).forEach((item, index, arr) => {
    const yAxis = (index + 1) * 18 + ((index + 1) * 8) + 46

    // const itemBgYaxis = (index + 1) * 18 + ((index + 1) * 8) + 30
    // 期號項目水平背景
    // ctx.beginPath()
    // ctx.fillStyle = '#ffffff'
    // ctx.fillRect(x + 2, y + itemBgYaxis, rectWidth - 4, 26)
    // ctx.fill()
    // ctx.closePath()

    // 期號
    ctx.fillStyle = '#000000'
    ctx.font = `${periodFontSize} ${fontFamily}`
    // ctx.fillText(item.period, x + 4, y + yAxis)
    letterSpacingText(ctx, item.period, x + 4, y + yAxis, periodLetterSpacing)

    // 分隔線
    const lineYaxis = y + yAxis + 10
    ctx.save()
    ctx.beginPath()
    ctx.moveTo(x + 2, lineYaxis)
    ctx.lineTo(x + rectWidth - 2, lineYaxis)
    ctx.strokeStyle = neutrialStyle
    if (arr.length - 1 === index) { // 最後一條線不顯示
      ctx.strokeStyle = 'rgba(255, 255, 255, 0)'
    }
    ctx.stroke()
    ctx.closePath()
    ctx.restore()

    ctx.font = `12px ${fontFamily}`

    Object.keys(item.missing).sort((a, b) => a.slice(3) - b.slice(3)).forEach((num, numIndex) => {
      const itemBoxXaxis = x + 38 + ((numIndex + 1) * boxWidth) + ((numIndex + 1) * 6)
      const itemBoxYaxis = y + ((index + 1) * boxWidth) + ((index + 1) * 8) + 46
      const itemMeasure = ctx.measureText(Math.abs(item.missing[num])).width
      ctx.beginPath()
      // 數字方塊
      const findTeam = teamColorList.find(item => item.number === Number(num.slice(3)))
      ctx.roundRect(itemBoxXaxis, itemBoxYaxis - 12, boxWidth, boxWidth, 2)
      ctx.fillStyle = '#F2F2F2'
      ctx.fill()
      ctx.closePath()

      ctx.save()
      // 非 highlight 數字
      ctx.fillStyle = '#000000'
      ctx.fillText(Math.abs(item.missing[num]), itemBoxXaxis - (itemMeasure / 2) + (boxWidth / 2), itemBoxYaxis + 2)

      if (item.missing[num] === 0) {
        points.push({ x: itemBoxXaxis - (ctx.measureText(findTeam.number).width / 2) + (boxWidth / 2) + 2, y: itemBoxYaxis - 2, number: index + 1 })
      }
      ctx.restore()
    })
  })

  // 折線圖
  ctx.beginPath()
  ctx.moveTo(points[0].x, points[0].y)
  for (let i = 1; i < points.length; i++) {
    ctx.lineTo(points[i].x, points[i].y)
  }
  ctx.strokeStyle = '#FF3D33'
  ctx.lineWidth = 1
  ctx.stroke()
  ctx.closePath()

  // 冠軍號碼定位
  champinshipMissing.slice(0, 10).forEach((item, index, arr) => {
    Object.keys(item.missing).sort((a, b) => a.slice(3) - b.slice(3)).forEach((num, numIndex) => {
      const itemBoxXaxis = x + 38 + ((numIndex + 1) * boxWidth) + ((numIndex + 1) * 6)
      const itemBoxYaxis = y + ((index + 1) * boxWidth) + ((index + 1) * 8) + 46
      // 數字方塊
      const findTeam = teamColorList.find(item => item.number === Number(num.slice(3)))
      if (item.missing[num] === 0) {
        ctx.save()
        ctx.beginPath()
        ctx.fillStyle = findTeam.teamColor
        ctx.roundRect(itemBoxXaxis, itemBoxYaxis - 12, boxWidth, boxWidth, 2)
        ctx.fill()
        ctx.closePath()
        ctx.restore()
        ctx.font = `12px ${params.fontFamily}`
        ctx.fillStyle = '#ffffff'
        ctx.fillText(findTeam.number, itemBoxXaxis - (ctx.measureText(findTeam.number).width / 2) + (boxWidth / 2), itemBoxYaxis + 2)
      }
      ctx.restore()
    })
  })
}

/**
 *  近60期冠軍統計
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布的2D渲染上下文。
 * @param {number} x - 統計區塊的起始x座標。
 * @param {number} y - 統計區塊的起始y座標。
 * @param {object} params - 自定義參數：
 *   - {number} rectWidth - 區塊的寬度（預設：canvasStyle.rectWidth）。
 *   - {string} fontFamily - 文字的字體（預設：canvasStyle.fontFamily）。
 *   - {number} blockBorderRaidus - 區塊邊框的半徑（預設：12）。
 *   - {string} blockBackgroundColor - 區塊的背景顏色（預設：'#FFFFFF'）。
 *   - {function} championshipBarChart - 柱状图的顯示函數（預設：空函數）。
 *   - {function} championshipCarTeamBlock - 車隊塊的顯示函數（預設：空函數）。
 */
export const championshipStatistics = (ctx, x, y, params = {}) => {
  const {
    rectWidth = canvasStyle.rectWidth, // 區塊寬度
    fontFamily = canvasStyle.fontFamily, // 字體
    blockBorderRaidus = 12, // 區塊圓角大小
    blockBackgroundColor = 'red',
    championshipBarChart = () => {},
    championshipCarTeamBlock = () => {}
  } = params
  ctx.beginPath()
  ctx.roundRect(x, y, rectWidth, 333, blockBorderRaidus)
  ctx.fillStyle = blockBackgroundColor
  ctx.fill()
  ctx.stroke()
  blockTitle(ctx, x, y, '近60期冠军统计')
  ctx.closePath()
  ctx.font = `50px ${fontFamily}`

  if (typeof championshipBarChart === 'function') {
    championshipBarChart()
  }
  if (typeof championshipCarTeamBlock === 'function') {
    championshipCarTeamBlock()
  }
}

/**
 * 近60期冠軍統計 柱狀圖
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布內容。
 * @param {number} x - 圖的 x 座標。
 * @param {number} y - 圖的 y 座標。
 * @param {Object} params - 圖的參數。
 * @param {Array} params.mapCarList - 冠榜車輛清單。
 * @param {string} params.fontFamily - 圖的字體家族。
 * @param {number} params.blockSpacing - 區塊之間的間距。
 * @return {void}
 */
export const championshipBarChart = (ctx, x, y, params = {}) => {
  const {
    mapCarList = [],
    fontFamily = canvasStyle.fontFamily,
    blockSpacing = canvasStyle.blockSpacing
  } = params
  const maxLineChartHeight = 76

  const lineChartPlaceBottomPos = y + 116

  const mapPercent = mapCarList.map(item => item.percent)

  // 找出最大值和最小值
  const maxPercent = Math.max(...mapPercent)
  const minPercent = Math.min(...mapPercent)

  // 計算範圍
  const range = maxPercent - minPercent

  // 計算兩個中間值
  const mid1 = Math.round(minPercent + range / 3)
  const mid2 = Math.round(minPercent + 2 * range / 3)

  // 圖表數值
  const percentList = [maxPercent, mid2, mid1, minPercent]

  const lineChartLineSpacingX = 20
  const lineChartLineSpacingY = 25

  // 分隔數值資訊
  const chartLineValue = percentList.map((item, index) => {
    return {
      value: item,
      pos: {
        x: x + 6,
        y: y + 40 + (lineChartLineSpacingY * index) + (12 / 2)
      }
    }
  })

  const dividerLineWidth = 1 // 分隔線寬
  // 圖表分隔線
  for (let i = 0; i < chartLineValue.length; i++) {
    ctx.fillStyle = '#77838F'
    ctx.font = `12px ${fontFamily}`
    ctx.fillText(chartLineValue[i].value, blockSpacing + chartLineValue[i].pos.x - (ctx.measureText(chartLineValue[i].value).width / 2), chartLineValue[i].pos.y - 2)
    ctx.beginPath()
    ctx.moveTo(x + lineChartLineSpacingX + 4, chartLineValue[i].pos.y - (12 / 2))
    ctx.lineTo(x + lineChartLineSpacingX + 260, chartLineValue[i].pos.y - (12 / 2))
    ctx.strokeStyle = '#dddddd'
    ctx.stroke()
    ctx.lineWidth = dividerLineWidth
    ctx.closePath()
  }

  mapCarList.forEach((car, index) => {
    const barHeight = ((car.percent - minPercent) / (maxPercent - minPercent)) * maxLineChartHeight
    // 長條圖
    ctx.beginPath()
    ctx.font = `12px ${fontFamily}`
    ctx.fillStyle = '#2E2A2A'
    const chartXaxis = x + 16 + (18 * (index + 1)) + (6 * index) // 整組長條圖水平偏移、個別長條圖水平偏移、個別長條圖水平間距
    const chartYaxis = y + 130
    const carNumber = `${car.number}号`
    const lineNumMeasure = ctx.measureText(carNumber).width
    ctx.fillText(carNumber, chartXaxis, chartYaxis)
    ctx.fillStyle = car.teamColor
    ctx.fillRect((chartXaxis + (lineNumMeasure / 2) / 2), lineChartPlaceBottomPos - barHeight, 12, barHeight)
    ctx.closePath()
    // 繪製與分隔線相同高度的長條圖
    if (car.percent === minPercent) {
      ctx.beginPath()
      ctx.fillStyle = car.teamColor // 柱狀圖顏色
      ctx.fillRect((chartXaxis + (lineNumMeasure / 2) / 2), lineChartPlaceBottomPos - barHeight - dividerLineWidth, 12, dividerLineWidth)
      ctx.closePath()
    }
  })
}

/**
 * 近60期冠軍統計 jspk10 車隊區塊資料
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布的2D渲染上下文。
 * @param {number} x - 區塊起點的x坐標。
 * @param {number} y - 區塊起點的y坐標。
 * @param {Object} params - 用於自定義的額外參數。
 */
export const championshipCarTeamBlock = (ctx, x, y, params = {}) => {
  const spacingY = 38
  const columns = 2
  const spacingX = 144
  const itemSpaceX = 12
  const itemSpaceY = 10
  const {
    mapCarList = [],
    fontFamily = canvasStyle.fontFamily,
    cpCode = 'jspk10'
  } = params
  mapCarList.forEach(async(car, index) => {
    const carNumber = `${car.number}号`
    const lineNumMeasure = ctx.measureText(carNumber).width

    ctx.font = `11px ${fontFamily}`
    const row = Math.floor(index / columns)
    const col = index % columns
    const xAxis = (col * spacingX) + itemSpaceX
    const yAxis = (row * spacingY) + itemSpaceY + 136

    const carImage = {
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/${cpCode}/car-image/car_${car.number}.png`),
      x: x + xAxis + itemSpaceX + 38,
      y: y + yAxis + itemSpaceY,
      width: 88,
      height: 20
    }
    // 車隊背景
    ctx.beginPath()
    ctx.roundRect(x + xAxis - 2, y + yAxis, spacingX - itemSpaceX, spacingY - itemSpaceY, 8)
    ctx.strokeStyle = car.teamColor
    ctx.fillStyle = car.teamColor
    ctx.lineWidth = 1
    ctx.fill()
    ctx.closePath()

    ctx.font = `600 11px ${fontFamily}`

    const itemContentXoffset = x + xAxis + 4
    const itemContentYoffset = y + yAxis + 12
    // 車隊號碼
    ctx.fillStyle = '#ffffff'
    ctx.fillText(carNumber, itemContentXoffset, itemContentYoffset)

    // 車隊名稱
    const teamName = car.team.cnName
    ctx.fillText(teamName, itemContentXoffset + lineNumMeasure + 2, itemContentYoffset)

    ctx.font = `11px ${fontFamily}`
    // 勝率 + 百分比 文字寬度
    const winningRate = `胜率${car.percent}%`
    ctx.fillText(winningRate, itemContentXoffset, itemContentYoffset + 12)

    await insertImage(ctx, x + spacingX, y, carImage)
  })
}

/**
 * 冠軍分析
 *
 * @param {CanvasRenderingContext2D} ctx - 用於繪製的畫布上下文。
 * @param {number} x - 圖表的 x 座標。
 * @param {number} y - 圖表的 y 座標。
 * @param {Object} params - 用於自定義圖表的可選參數。
 * @param {Array} params.mapData - 用於填充圖表的數據。
 * @param {Array} params.numberImageList - 用於數字的圖像列表。
 * @param {Object} params.biggestMissing - 數據中最大的遺漏值。
 * @param {number} params.rectWidth - 圖表矩形的寬度。
 * @param {string} params.fontFamily - 圖表中使用的字體系列。
 * @param {number} params.blockSpacing - 圖表區塊之間的間距。
 * @param {string} params.blockStrokeStyle - 區塊邊框的顏色。
 * @param {number} params.blockBorderRaidus - 區塊邊框的半徑。
 * @param {string} params.blockBackgroundColor - 區塊的背景顏色。
 */
export const championshipAnalysis = (ctx, x, y, params = {}) => {
  const {
    mapData = [],
    numberImageList = [],
    biggestMissing = {},
    rectWidth = canvasStyle.rectWidth, // 區塊寬度
    fontFamily = canvasStyle.fontFamily, // 字體
    blockSpacing = canvasStyle.blockSpacing, // 區塊間距
    blockStrokeStyle = canvasStyle.blockStrokeStyle, // 區塊邊框顏色
    blockBorderRaidus = 12, // 區塊圓角大小
    blockBackgroundColor = '#FFFFFF'
  } = params

  ctx.beginPath()
  ctx.roundRect(x, y, rectWidth, 132, blockBorderRaidus)
  ctx.fillStyle = blockBackgroundColor
  ctx.fill()
  ctx.strokeStyle = blockStrokeStyle
  ctx.lineWidth = 2
  ctx.stroke()
  blockTitle(ctx, x, y, '冠军分析')
  ctx.closePath()

  ctx.font = `50px ${fontFamily}`
  blockTitle(ctx, x + rectWidth - blockSpacing - (14 * 4), y, '近20期')
  ctx.font = `14px ${fontFamily}`

  const hm1 = mapData.find((item) => item.field === 'hm1') || {}
  const { hot, warm, cold } = hm1
  const itemYaxis = y + 34
  ctx.fillStyle = '#FF3D33'
  ctx.fillText('热', x + blockSpacing, itemYaxis + 14)
  const hotArray = Array.isArray(hot) && hot.length > 0 ? hot : []
  hotArray.sort((a, b) => a.num - b.num).reverse().forEach(async(item, index) => {
    await insertImage(ctx, x, y, {
      x: x + rectWidth - ((index + 1) * 20) - (index * 2) - blockSpacing,
      y: itemYaxis,
      path: numberImageList[item.num - 1].imgPath,
      width: 20,
      height: 20
    })
  })

  ctx.fillStyle = '#FF7C43'
  ctx.fillText('温', x + blockSpacing, itemYaxis + 20 + 4 + 14)
  const warmArray = Array.isArray(warm) && warm.length > 0 ? warm : []
  warmArray.sort((a, b) => a.num - b.num).reverse().forEach(async(item, index) => {
    await insertImage(ctx, x, y, {
      x: x + rectWidth - ((index + 1) * 20) - (index * 2) - blockSpacing,
      y: itemYaxis + 20 + 4,
      path: numberImageList[item.num - 1].imgPath,
      width: 20,
      height: 20
    })
  })

  ctx.fillStyle = '#0175D3'
  ctx.fillText('冷', x + blockSpacing, itemYaxis + (20 * 2) + (4 * 2) + 14)
  const coldArray = Array.isArray(cold) && cold.length > 0 ? cold : []
  coldArray.sort((a, b) => a.num - b.num).reverse().forEach(async(item, index) => {
    await insertImage(ctx, x, y, {
      x: x + rectWidth - ((index + 1) * 20) - (index * 2) - blockSpacing,
      y: itemYaxis + (20 * 2) + (4 * 2),
      path: numberImageList[item.num - 1].imgPath,
      width: 20,
      height: 20
    })
  })

  ctx.fillStyle = '#000000'
  const minValue = Math.min(...Object.values(biggestMissing))
  const allMinValues = Object.entries(biggestMissing) // 找出最大遗漏的數字陣列
    .filter(([key, value]) => value === minValue)
    .map(([key, value]) => ({ text: key, num: value }))

  ctx.fillText('最大遗漏', x + blockSpacing, itemYaxis + (20 * 3) + (4 * 3) + 14)

  allMinValues.sort((a, b) => a.text.replace('num', '') - b.text.replace('num', '')).reverse().forEach(async(item, index) => {
    const findNum = numberImageList.find((n) => n.num === Number(item.text.replace('num', '')))
    await insertImage(ctx, x, y, {
      x: x + rectWidth - ((index + 1) * 20) - (index * 2) - blockSpacing,
      y: itemYaxis + (20 * 3) + (4 * 3),
      path: numberImageList[findNum.num - 1].imgPath,
      width: 20,
      height: 20
    })
  })
}

/**
 * 開獎歷史
 *
 * @param {CanvasRenderingContext2D} ctx - 要繪製的畫布上下文。
 * @param {number} x - 繪製區域左上角的 x 座標。
 * @param {number} y - 繪製區域左上角的 y 座標。
 * @param {Object} [params={}] - 自定義繪製的可選參數。
 * @param {Object} [params.getMultiTrendData={}] - 用於繪製的資料。
 * @param {Array} [params.danShuangHistoryData=[]] - 用於繪製的單雙歷史資料。
 * @param {Array} [params.numberImageList=[]] - 數字圖片清單。
 * @param {number} [params.rectWidth=canvasStyle.rectWidth] - 繪製區域的寬度。
 * @param {string} [params.fontFamily=canvasStyle.fontFamily] - 繪製使用的字體。
 * @param {number} [params.blockSpacing=canvasStyle.blockSpacing] - 繪製中區塊之間的間距。
 * @param {number} [params.rightSideRectWidth=rectWidth + 12] - 繪製區域右側的寬度。
 * @param {string} [params.blockStrokeStyle=canvasStyle.blockStrokeStyle] - 繪製中區塊的邊框顏色。
 * @param {number} [params.blockBorderRaidus=12] - 繪製中區塊的圓角大小。
 * @param {string} [params.blockBackgroundColor='#FFFFFF'] - 繪製中區塊的背景顏色。
 * @param {number} [params.periodFontStyle.periodFontSpacing=0] - 期數文字間距
 * @param {string} [params.periodFontStyle.periodFontSize='11px'] - 期數文字的字體大小。
 * @return {void}
 */
export const lotteryHistory = async(ctx, x, y, params = {}) => {
  const {
    getMultiTrendData = {},
    danShuangHistoryData = [],
    numberImageList = [],
    rectWidth = canvasStyle.rectWidth, // 區塊寬度
    fontFamily = canvasStyle.fontFamily, // 字體
    blockSpacing = canvasStyle.blockSpacing, // 區塊間距
    rightSideRectWidth = rectWidth + 12,
    blockStrokeStyle = canvasStyle.blockStrokeStyle, // 區塊邊框顏色
    blockBorderRaidus = 12, // 區塊圓角大小
    blockBackgroundColor = '#FFFFFF',
    periodFontStyle: {
      periodFontSpacing = 0, // 期數文字間距
      periodFontSize = '11px'
    } = {}
  } = params
  ctx.beginPath()
  ctx.roundRect(x, y, rightSideRectWidth, 406, blockBorderRaidus)
  ctx.fillStyle = blockBackgroundColor
  ctx.fill()
  ctx.strokeStyle = blockStrokeStyle
  ctx.stroke()
  blockTitle(ctx, x, y, '开奖历史')
  blockTitle(ctx, x + rectWidth - (16 * 10), y, '冠军单双命中')
  ctx.closePath()

  ctx.font = `50px ${fontFamily}`

  function generateData(danShuangHistory) {
    const data = []
    for (let i = 0; i < danShuangHistory.length; i++) {
      const { period, balls, wins, danShuangGuess } = danShuangHistory[i]
      const num = balls
      const isGuessed = Boolean(wins)
      const result = danShuangGuess.split('_')[1]

      data.push({
        period,
        num,
        isGuessed,
        result
      })
    }

    return data.reverse()
  }
  const data = generateData(danShuangHistoryData)
  const mapData = data.reduce((acc, current, index) => {
    const mapNumList = current.num ? (Array.isArray(current.num) && current.num.length > 0 ? current.num.map((item) => {
      return `${numberImageList[item - 1].imgPath}`
    }) : []) : []
    acc.push({
      ...current,
      mapNumList
    })
    return acc
  }, [])

  // 冠軍單雙命中率圖
  const percentImageList = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
  const championshipPercentList = percentImageList.map((item) => {
    return {
      num: item,
      imgPath: require(`@/assets/style/desktop/img/canvas-image/PK10/percent/${item}p.png`)
    }
  })

  // 插入冠軍單雙命中率圖
  // 找出 item.num (balls) 長度為 0 且 isGuessed 為 true 的資料
  const checkMapData = mapData.filter(item => Array.isArray(item.num) && item.num.length === 0 && item.isGuessed)
  const winRatePercent = mapData.filter(item => item.isGuessed).length
  if (!checkMapData.length > 0) {
    await insertImage(ctx, x, y, {
      path: championshipPercentList[winRatePercent].imgPath,
      x: x + (rightSideRectWidth) - 76,
      y: y - 16,
      width: 76,
      height: 62
    })
  }

  mapData.forEach(async(item, index) => {
    ctx.font = `${periodFontSize} ${fontFamily}`
    const yAxis = (((index + 1) * 18) + ((index + 1) * 10))
    const itemYaxis = y + yAxis + 10
    ctx.fillStyle = '#000000'
    letterSpacingText(ctx, item.period, x + blockSpacing - 4, y + yAxis + 24, periodFontSpacing)
    item.mapNumList.forEach(async(num, numIndex) => {
      await insertImage(ctx, x, y, {
        x: x + (((numIndex + 1) * 18) + (numIndex * 2)) + 50,
        y: itemYaxis,
        path: num,
        width: 18,
        height: 18
      })
    })
    // 命中
    if (Array.isArray(item.num) && item.num.length > 0 && item.isGuessed) {
      await insertImage(ctx, x, y, {
        x: x + rectWidth - (18 * 2) + 4,
        y: itemYaxis,
        path: require(`@/assets/style/desktop/img/canvas-image/PK10/zhong.png`),
        width: 18,
        height: 18
      })
    }
    // 單雙
    if (Array.isArray(item.num) && item.num.length > 0) {
      await insertImage(ctx, x, y, {
        x: x + rectWidth - 18 + 8,
        y: itemYaxis,
        path: require(`@/assets/style/desktop/img/canvas-image/PK10/${item.result}.png`),
        width: 18,
        height: 18
      })
    }
  })

  await insertImage(ctx, x, y, {
    x: x + 16,
    y: y + 320,
    path: require(`@/assets/style/desktop/img/canvas-image/PK10/dash_line.png`),
    width: 276,
    height: 2
  })

  // 90期冠军统计
  blockTitle(ctx, x + 6, y + 320, '90期冠军统计')

  const { hmDanShuang, hmDaXiao, hmJhihHe } = getMultiTrendData.stats.appearCount
  const campionshipPeriod = [
    {
      num: hmDanShuang['hm1']['danshuang_dan'],
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/dan.png`)
    },
    {
      num: hmDanShuang['hm1']['danshuang_shuang'],
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/shuang.png`)
    },
    {
      num: hmDaXiao['hm1']['daxiao_da'],
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/da.png`)
    },
    {
      num: hmDaXiao['hm1']['daxiao_xiao'],
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/xiao.png`)
    },
    {
      num: hmJhihHe['hm1']['jhihHe_jhih'],
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/zhi.png`)
    },
    {
      num: hmJhihHe['hm1']['jhihHe_he'],
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/he.png`)
    }
  ]
  campionshipPeriod.forEach(async(item, index) => {
    ctx.font = `14px ${fontFamily}`
    ctx.fillText(item.num, x + (((index + 1) * 24) + (index * 28)) + 4 - 10, y + 394)
    await insertImage(ctx, x, y, {
      x: x + (((index + 1) * 24) + (index * 28)) - 10,
      y: y + 354,
      path: item.path,
      width: 24,
      height: 24
    })
  })
}

/**
 * 冠亞預測
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布上下文。
 * @param {number} x - 起始點的x坐標。
 * @param {number} y - 起始點的y坐標。
 * @param {Object} params - 繪製預測的參數。
 * @param {Object} params.carList - 車輛列表。
 * @param {Array} params.circuitItem - 賽道項目列表。
 * @param {Function} params.getRandomCarTeam - 獲取隨機車隊的函數。
 * @param {number} params.rectWidth - 矩形的寬度。
 * @param {string} params.fontFamily - 字體家族。
 * @param {number} params.rightSideRectWidth - 右側矩形的寬度。
 * @param {number} params.blockBorderRadius - 塊邊框的半徑。
 * @param {string} params.blockBackgroundColor - 塊的背景顏色。
 * @param {string} params.blockStrokeStyle - 塊的描邊樣式。
 * @param {number} params.blockSpacing - 塊的間距。
 * @param {Object} that - 外部傳入的 this。
 */
export const championAndRunnerUpPredictions = async(ctx, x, y, params = {}, that) => {
  const {
    carList = {},
    circuitItem = [],
    getRandomCarTeam = {},
    rectWidth = canvasStyle.rectWidth,
    fontFamily = canvasStyle.fontFamily,
    rightSideRectWidth = rectWidth + 12,
    blockBorderRaidus = 12, // 區塊圓角大小
    blockBackgroundColor = canvasStyle.blockBackgroundColor,
    blockStrokeStyle = canvasStyle.blockStrokeStyle,
    blockSpacing = canvasStyle.blockSpacing
  } = params
  ctx.beginPath()
  ctx.roundRect(x, y, rightSideRectWidth, 190, blockBorderRaidus)
  ctx.fillStyle = blockBackgroundColor
  ctx.fill()
  ctx.strokeStyle = blockStrokeStyle
  ctx.lineWidth = 2
  ctx.stroke()
  blockTitle(ctx, x, y, '冠亚预测')
  ctx.closePath()

  const guanbg = {
    path: require(`@/assets/style/desktop/img/canvas-image/PK10/guan_ya_bg.png`),
    x: x + rightSideRectWidth - 116,
    y: y - 16,
    width: 116,
    height: 110
  }

  // 隨機取得兩個車隊
  const getRandomTwoCar = getRandomTwoPair(
    Object.keys(carList),
    carList[getRandomCarTeam].number
  )
  const guanYaImgSize = {
    width: 24,
    height: 24
  }
  that.guanNum = carList[getRandomTwoCar.firstPair].number
  const yaNum = carList[getRandomTwoCar.secondPair].number
  const getGuanYaYuCe = guanYaYuCe(that.guanNum, yaNum)

  ctx.font = `14px ${fontFamily}`
  wrapText(
    ctx,
    `依据[${circuitItem.title}]开奖历史与定位走势的遗漏数据，冠军[${that.guanNum}号车手]呼声最高，亚军看好[${yaNum}号车手]，依据冠亚和统计，此10期冠亚和值高机率落在${getGuanYaYuCe.start}-${getGuanYaYuCe.end}之间。`,
    x + blockSpacing,
    y + 110,
    rectWidth - blockSpacing,
    20,
    0
  )
  await insertImage(ctx, x, y, guanbg, async() => {
    const guanNumImg = {
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/square-number/${that.guanNum}.png`),
      x: guanbg.x + blockSpacing + 6,
      y: guanbg.y + guanbg.height - guanYaImgSize.height - 4,
      ...guanYaImgSize
    }
    const yaNumImg = {
      path: require(`@/assets/style/desktop/img/canvas-image/PK10/square-number/${yaNum}.png`),
      x: guanbg.x + guanYaImgSize.width + blockSpacing * 4,
      y: guanbg.y + guanbg.height - guanYaImgSize.height - 4,
      ...guanYaImgSize
    }

    await insertImage(ctx, x, y, guanNumImg)
    await insertImage(ctx, x, y, yaNumImg)
  })

  const guanRing = {
    path: require(`@/assets/style/desktop/img/canvas-image/PK10/guan_ya_ring.png`),
    x: x + 30,
    y: y + 40,
    width: 166,
    height: 42
  }

  await insertImage(ctx, guanRing.x, guanRing.y, guanRing, () => {
    ctx.save()
    ctx.translate(guanRing.x, guanRing.y)
    ctx.rotate((-5 * Math.PI) / 180)
    ctx.font = `24px ${fontFamily}`
    ctx.fillStyle = '#000000'
    ctx.fillText(
      `冠亚和${getGuanYaYuCe.start}-${getGuanYaYuCe.end}`,
      16, guanRing.height - 4
    )
    ctx.restore()
  })
}

/**
 * 最新10期冠軍預測
 *
 * @param {CanvasRenderingContext2D} ctx - 畫布的 2D 渲染上下文。
 * @param {number} x - 區塊起始點的 x 座標。
 * @param {number} y - 區塊起始點的 y 座標。
 * @param {Object} params - 包含自定義參數的物件。
 * @param {Object} [params.predictDanShuang=[]] - 用於繪製的資料。
 * @param {number} [params.rectWidth=canvasStyle.rectWidth] - 繪製區域的寬度。
 * @param {number} [params.blockBorderRaidus=12] - 繪製中區塊的圓角大小。
 * @param {string} [params.blockStrokeStyle=canvasStyle.blockStrokeStyle] - 繪製中區塊的邊框顏色。
 * @param {string} [params.blockBackgroundColor='#FFFFFF'] - 繪製中區塊的背景顏色。
 */
export const latestChampionshipPredictions = (ctx, x, y, params = {}) => {
  const {
    predictDanShuang = [],
    rectWidth = canvasStyle.rectWidth, // 區塊寬度
    blockStrokeStyle = canvasStyle.blockStrokeStyle, // 區塊邊框顏色
    blockBorderRaidus = 12, // 區塊圓角大小
    blockBackgroundColor = '#FFFFFF',
    predictionBlock = () => {}
  } = params

  ctx.beginPath()
  ctx.roundRect(x, y, rectWidth, 132, blockBorderRaidus)
  ctx.fillStyle = blockBackgroundColor
  ctx.fill()
  ctx.strokeStyle = blockStrokeStyle
  ctx.lineWidth = 2
  ctx.stroke()
  blockTitle(ctx, x, y, '最新10期冠军预测⮕')
  ctx.closePath()

  // 10期冠軍預測區塊的繪圖座標
  const dataPos = [
    { x: 2, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 1 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 2 },
    { x: 2, y: 2 },
    { x: 0, y: 3 },
    { x: 1, y: 3 },
    { x: 2, y: 3 }
  ]
  const mapDanShuang = predictDanShuang.map((item, index) => {
    const findItem = dataPos.find((d, i) => i === index)
    return {
      ...item,
      ...findItem
    }
  })
  ctx.save()
  ctx.translate(x, y)
  ctx.fillStyle = '#000000'
  mapDanShuang.forEach((item) => {
    // 10期冠軍預測單雙圖
    let imgPath = null
    if (item.danShuangGuess) {
      imgPath = require(`@/assets/style/desktop/img/canvas-image/PK10/${item.danShuangGuess === 'danshuang_dan' ? 'dan' : 'shuang'}.png`)
    }
    const imgInfo = {
      path: imgPath,
      x: item.x + 2,
      y: item.y + 18,
      width: 18,
      height: 18
    }
    if (typeof predictionBlock === 'function') {
      predictionBlock(params, imgInfo, item)
    }
  })
  ctx.restore()
}

/**
 * canvas 單行文字字距
 *
 * @param {CanvasRenderingContext2D} ctx - canvas 的2D渲染上下文
 * @param {string} text - 要渲染的文字
 * @param {number} x - 文本的x座標
 * @param {number} y - 文本的y座標
 * @param {number} letterSpacing - 字母之間的間距
 */
export const letterSpacingText = (ctx, text, x, y, letterSpacing) => {
  if (!letterSpacing) {
    ctx.fillText(text, x, y)
    return
  }

  const arrText = text.split('')
  const align = ctx.textAlign || 'left'
  const originWidth = ctx.measureText(text).width
  const actualWidth = originWidth + letterSpacing * (arrText.length - 1)

  if (align === 'center') {
    x = x - actualWidth / 2
  } else if (align === 'right') {
    x = x - actualWidth
  }

  ctx.textAlign = 'left'

  arrText.forEach((letter) => {
    const letterWidth = ctx.measureText(letter).width
    ctx.fillText(letter, x, y)
    x = x + letterWidth + letterSpacing
  })

  ctx.textAlign = align
}

/**
 * canvas 文字換行與縮減字間距
 *
 * @param {CanvasRenderingContext2D} ctx - canvas 的2D渲染上下文
 * @param {string} text - 要填入的文字內容.
 * @param {number} x - x 坐標.
 * @param {number} y - y 坐標.
 * @param {number} maxWidth - 文字最大寬度
 * @param {number} lineHeight - 文字行高
 * @param {number} letterSpacing - 文字間距
 * @param {function} callback - callback
 */
export const wrapText = (ctx, text, x, y, maxWidth, lineHeight, letterSpacing, callback) => {
  if (
    typeof text !== 'string' ||
            typeof x !== 'number' ||
            typeof y !== 'number'
  ) {
    return
  }

  if (typeof maxWidth === 'undefined') {
    maxWidth = (ctx.canvas && ctx.canvas.width) || 300
  }
  if (typeof lineHeight === 'undefined') {
    lineHeight =
                (ctx.canvas && parseInt(getComputedStyle(ctx.canvas).lineHeight)) ||
                parseInt(getComputedStyle(document.body).lineHeight)
  }

  const arrText = text.split('')
  let line = ''

  for (let n = 0; n < arrText.length; n++) {
    const testLine = line + arrText[n]
    const metrics = ctx.measureText(testLine)
    const testWidth = metrics.width + letterSpacing * (testLine.length - 1)
    if (testWidth > maxWidth && n > 0) {
      letterSpacingText(ctx, line, x, y, letterSpacing)
      line = arrText[n]
      y += lineHeight
    } else {
      line = testLine
    }
  }
  letterSpacingText(ctx, line, x, y, letterSpacing)
  if (typeof callback === 'function') callback()
}

export const loadImage = (imgPath = '') => {
  return new Promise((resolve, reject) => {
    const imgObj = new Image()

    if (!imgObj.complete) {
      reject(new Error('image load failed'))
    } else {
      imgObj.onload = () => resolve(imgObj)
      imgObj.src = imgPath
    }
  })
}

export async function getNewsPaperImageURL(vm, params) {
  // vm.$emit('input', true) // 讀取畫面
  const isRequestSuccessful = (result) => {
    if (!result || !result[0]) {
      return false
    }
    return result[0].imgURL !== ''
  }
  const action = vm.drawParams?.action || ''
  const authorization = vm.drawParams?.authorization || ''
  const isFromEnduser = !action && !authorization
  if (isFromEnduser) {
    const [data] = await retryOrPollUntil({
      operation: getNewsPaperURL,
      operationArgs: [params],
      isSuccessful: isRequestSuccessful,
      maxAttempts: 10,
      delaySeconds: 10
    })
    if (data && data.imgURL !== '') {
      vm.$store.dispatch('lottery/setCanvasNewsURL', data.imgURL)
    } else {
      vm.$store.dispatch('lottery/setPaperFetchMessage', fetchDataErrorText)
    }
    // vm.$emit('input', false) // 讀取畫面
  }

  if (action === 'draw') {
    vm.createCanvasNews()
    return
  }
}

// 報紙產圖彩種選單資料
export const newspaperMenuListInfo = {
  sixhc: {
    label: '六合彩',
    src: require('@/assets/style/desktop/img/newspaper-menu/liuHe.png'),
    key: 'sixhc',
    children: []
  },
  pk10: {
    label: 'PK拾',
    src: require('@/assets/style/desktop/img/newspaper-menu/pk10.png'),
    key: 'pk10',
    children: []
  },
  ssc: {
    label: '时时彩',
    src: require('@/assets/style/desktop/img/newspaper-menu/ssc.png'),
    key: 'ssc',
    children: []
  },
  '11x5': {
    label: '11选5',
    src: require('@/assets/style/desktop/img/newspaper-menu/11x5.png'),
    key: '11x5',
    children: []
  }
}

// 報紙產圖彩種選單 keys 陣列
export const cpTypeKeys = Object.keys(newspaperMenuListInfo)

// 報紙產圖彩種選單函式
/**
 * 將用 tukuTabs 和 cpTypeDetail 產生一個新的選單資料
 * @param {Object} tukuTabs - 關聯的 cpType
 * @param {Object} cpTypeDetail - 關聯的 cpType 詳細資料
 * @param {string} baseUrl -  URL 的基底路徑，預設為 '/images'
 * @returns {Object[]} 新的選單資料
 */
export function mapTukuTab({ tukuTabs = {}, cpTypeDetail = {}, baseUrl = '/images' } = {}) {
  const tabOrder = Object.keys(tukuTabs)
  const menuInfo = JSON.parse(JSON.stringify(newspaperMenuListInfo))
  // 為每個相關的 cpType 填充子項目
  Object.keys(menuInfo).forEach(cpType => {
    if (tukuTabs[cpType] && cpTypeDetail[cpType]) {
      const children = tukuTabs[cpType]
        .map(code => {
          const details = cpTypeDetail[cpType]?.[code]
          if (details && details.name) {
            return {
              lotteryCode: code,
              natureLink: cpType === 'sixhc' ? `${baseUrl}/liuHe?lotteryCode=${code}` : `${baseUrl}/${cpType}?lotteryCode=${code}`,
              name: details.name
            }
          }
          return null
        })
        .filter(Boolean) // 過濾掉空值

      menuInfo[cpType].children = children
    }
  })

  // 按照指定的順序返回選單，過濾掉可能不存在的選項
  return tabOrder
    .map(type => menuInfo[type])
    .filter(Boolean)
}

// 報紙產圖彩種分類對應標題
export const typeMapTitle = {
  liuHe: '六合图库',
  pk10: 'PK拾图库',
  ssc: '时时彩图库',
  '11x5': '11选5图库'
}
